import { useTranslation } from 'react-i18next';
import { LuArrowLeft } from 'react-icons/lu';

import { OverflowMenu } from './OverflowMenu';
import { CHAT_WINDOW_STATES } from '~/features/whatsapp/constants/chatStatus';
import { useIsCommunicationPage } from '~/features/whatsapp/hooks/useIsCommunicationPage';
import { popChatPanelView } from '~/features/whatsapp/stores/chatPanelStore';
import { deriveWindowState } from '~/features/whatsapp/utils/deriveChatStatus';
import { getInitials } from '~/features/whatsapp/utils/getInitials';
import { cn } from '~/utils/cnTailwind';

type Props = {
    canLink: boolean;
    chatId: string;
    displayName: string;
    lastInboundAt: number | null | undefined;
    loanRequestIds: Array<string>;
    resolved: boolean;
};

export const ChatHeader = ({ canLink, chatId, displayName, lastInboundAt, loanRequestIds, resolved }: Props) => {
    const { t } = useTranslation();
    const isCommunicationPage = useIsCommunicationPage();
    const windowState = deriveWindowState(lastInboundAt);

    return (
        <div className="flex shrink-0 items-center gap-2 border-b border-outline-light py-3 pl-4 pr-11">
            <button
                type="button"
                onClick={popChatPanelView}
                aria-label={t('WHATSAPP_CHAT.CHAT.BACK')}
                className="p-1 text-midnight"
            >
                <LuArrowLeft />
            </button>
            <span className="flex size-8 shrink-0 items-center justify-center rounded-full bg-grey-light text-sm font-semibold text-grey">
                {getInitials(displayName)}
            </span>
            <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                    <span className="truncate text-sm font-semibold text-midnight">{displayName}</span>
                    {windowState !== CHAT_WINDOW_STATES.NO_INBOUND_YET && (
                        <span
                            className={cn(
                                'shrink-0 rounded-full px-1.5 py-0.5 text-xs font-semibold',
                                windowState === CHAT_WINDOW_STATES.OPEN
                                    ? 'bg-status-green-bg text-status-green-text'
                                    : 'bg-status-yellow-bg text-status-yellow-text',
                            )}
                        >
                            {windowState === CHAT_WINDOW_STATES.OPEN
                                ? t('WHATSAPP_CHAT.STATUS.WINDOW_OPEN')
                                : t('WHATSAPP_CHAT.STATUS.WINDOW_EXPIRED')}
                        </span>
                    )}
                </div>
            </div>
            <div className={cn(!isCommunicationPage && 'mt-0.5 self-start')}>
                <OverflowMenu canLink={canLink} chatId={chatId} loanRequestIds={loanRequestIds} resolved={resolved} />
            </div>
        </div>
    );
};
